import { Component } from '@angular/core';

@Component({
  selector: 'app-available-slots-dialog-actions',
  templateUrl: './available-slots-dialog-actions.component.html',
  styleUrl: './available-slots-dialog-actions.component.scss',
})
export class AvailableSlotsDialogActionsComponent {}
